export const FeatureGamePage = {
  LabelSponsoredAd: 'Label.SponsoredAd',
  LabelNoSearchResults: 'LabelNoSearchResults',
  LabelPlayingOnePlusUsersWithComma: 'LabelPlayingOnePlusUsersWithComma',
  LabelPlayingOneUser: 'LabelPlayingOneUser',
  LabelBy: 'LabelCreatorBy',
  LabelByPrefix: 'Label.By'
};

export const CommonGameSorts = {
  LabelApiError: 'Label.ApiError',
  LabelGames: 'Label.Games'
};

export const FeaturePlacesList = {
  ActionSeeAll: 'Action.SeeAll',
  LabelGenreExplorerName: 'Label.GenreExplorerName'
};

export const FeatureGameDetails = {
  HeadingDescription: 'Heading.Description',
  LabelAgeGuidelines: 'Label.AgeGuidelines',
  LabelBy: 'Label.By',
  LabelPlaying: 'Label.Playing',
  LabelFavorites: 'Label.Favorites',
  LabelVisits: 'Label.Visits',
  LabelCreated: 'Label.Created',
  LabelUpdated: 'Label.Updated',
  LabelMaxPlayers: 'Label.MaxPlayers',
  LabelGenre: 'Label.Genre',
  LabelAllowedGear: 'Label.AllowedGear',
  LabelReportAbuse: 'Label.ReportAbuse',
  LabelPlaceCopyingAllowed: 'Label.PlaceCopyingAllowed',
  LabelVoiceEnabled: 'Label.VoiceEnabled',
  LabelYes: 'Label.Yes',
  LabelNo: 'Label.No',
  LabelUnavailable: 'Label.Unavailable',
  LabelSuitableForEveryone: 'Label.SuitableForEveryone',
  HeadingRecommendedGames: 'Heading.RecommendedGames'
};

export const FeatureGearOptionsDisplay = {
  LabelAllGenreAllowed: 'LabelAllGenreAllowed',
  LabelGearOnly: 'LabelGearOnly',
  LabelNoGear: 'LabelNoGear'
};

export const FeatureGamePass = {
  ActionAddPass: 'Action.AddPass',
  HeadingPassesForThisGame: 'Heading.PassesForThisGame',
  LabelBuy: 'Label.Buy',
  LabelOwned: 'Label.Owned',
  LabelNoPasses: 'Label.NoPasses'
};

export const FeatureSocialShare = {
  LabelInviteExpiredError: 'Label.InviteExpiredError',
  LabelInviterNotHereError: 'Label.InviterNotHereError',
  DescriptionInviteExpiredError: 'Description.InviteExpiredError',
  DescriptionInviterNotHereError: 'Description.InviterNotHereError',
  LabelCancel: 'Label.Cancel',
  LabelPlay: 'Label.Play'
};

export default {
  CommonGameSorts,
  FeatureGameDetails,
  FeatureGamePage,
  FeatureGamePass,
  FeatureGearOptionsDisplay,
  FeaturePlacesList,
  FeatureSocialShare
};
